// extracted by mini-css-extract-plugin
export default {"files":"reportsPage_files__KiThO","file":"reportsPage_file__f5zRl","file_name":"reportsPage_file_name__7gLD+","file_format":"reportsPage_file_format__t8azg"};